export default {
	container: {
		background: '#fcfefe',
    borderRadius: '3px',
    boxShadow: '0 3px 8px -6px rgba(0,0,0,0.45)',
    padding: '12px',
    position: 'relative',
    marginBottom: '16px',
	}
}
